import { render, staticRenderFns } from "./RadialGoal.vue?vue&type=template&id=79d038fe&"
import script from "./RadialGoal.vue?vue&type=script&lang=js&"
export * from "./RadialGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports